export enum DigitalIdCardChangeReasonText {
    NeverReceivedCard = 'Never received card',
    LostStolenDamaged = 'Lost, stolen, or damaged',
    Other = 'Other'
}
